import { useEffect, useState } from 'react'
import { api } from './api'
import { Modal } from './Modal'

type Device = {
  id: string
  name: string
  createdAt: string
  lastSeenAt: string
}

export function Devices({ onClose, onCurrentRevoked }: {
  onClose: () => void
  onCurrentRevoked: () => void
}) {
  const [devices, setDevices] = useState<Device[]>([])
  const [currentDeviceId, setCurrentDeviceId] = useState('')
  const [pairing, setPairing] = useState<{ code: string; expiresAt: string } | null>(null)

  async function load() {
    const result = await api<{ devices: Device[]; currentDeviceId: string }>('/api/devices')
    setDevices(result.devices)
    setCurrentDeviceId(result.currentDeviceId)
  }

  useEffect(() => {
    void load()
  }, [])

  async function createCode() {
    setPairing(await api('/api/pairings', {
      method: 'POST',
      body: JSON.stringify({}),
    }))
  }

  async function revoke(device: Device) {
    if (!window.confirm(`撤销“${device.name}”的访问权限？`)) return
    await api(`/api/devices/${device.id}`, { method: 'DELETE' })
    if (device.id === currentDeviceId) {
      onCurrentRevoked()
      return
    }
    await load()
  }

  return (
    <Modal title="受信设备" onClose={onClose}>
      <div className="pair-device-panel">
        {pairing ? (
          <div className="pairing-code">
            <span>{pairing.code}</span>
            <small>10 分钟内在新设备输入；使用一次后立即失效。</small>
          </div>
        ) : (
          <button className="primary-button compact" onClick={() => void createCode()}>
            配对新设备
          </button>
        )}
      </div>
      <div className="device-list">
        {devices.map((device) => (
          <div className="device-row" key={device.id}>
            <div>
              <strong>{device.name}{device.id === currentDeviceId ? '（当前）' : ''}</strong>
              <small>最后使用：{new Date(device.lastSeenAt).toLocaleString('zh-CN')}</small>
            </div>
            <button className="danger-text" onClick={() => void revoke(device)}>撤销</button>
          </div>
        ))}
      </div>
    </Modal>
  )
}
